    <template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <h1 class="titulo"> Cadastro de Despesas </h1>
        
      <div class="box-table mt-4">
        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="listaItens"
            width="300px"
            flat
            hide-default-footer
            :loading="loadingPag"
            :items-per-page.sync="itemsPerPage"
            class="table-installations"> 

            <template v-slot:item.created="{ item }">
              {{ item.created | datas('DD/MM/YYYY HH:mm:ss') }}
            </template>

            <template v-slot:top>

              <BrToolBar @search="buscar" :configFilter="{ getItens: getItens, jsonData: false }" :addlFilter="true" :labelTextField="'Nome'"/>
                <v-row class="justify-end">
                  <v-col cols="12" md="12" class="py-0 mb-2">

                  </v-col>
                </v-row>
            </template>          

            <template v-slot:item.action="{ item }">
              <v-tooltip top>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    @click="editItem(item)"
                    tile
                    outlined 
                    :color="variables.colorPrimary"
                    class="mr-2"
                    v-on="on"
                  >
                    Editar
                  </v-btn>
                </template>
                <span>{{ item.id }}</span>

              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="permiteAcao($route, 'delete')"
                    class="mr-2"
                    small
                    @click="deleteItem(item)"
                    tile
                    outlined 
                    :color="variables.colorError"
                    v-on="on"
                  >
                    Excluir
                  </v-btn>
                </template>
                <span>{{ item.id }}</span>
              </v-tooltip>
            </template>

            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="7"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>

      <v-btn class="mx-2 fab-cadastrar-usuario" fab color="primary" @click="cadastrar">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line
import { errorSnackbar, successSnackbar } from '@/core/service/utils'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'
import Events from '@/core/service/events'
export default {
  name: 'expenseConfigs',
  components: {
    BrToolBar: () => import('./components/toolbar')
  },
  mixins: [listagemTables],
  mounted () {
    Events.$on('reload::table::index', () => {
      this.loadingPag = true
      this.getItens().finally(() => {
        this.loadingPag = false        
      })

    })
  },

  data: () => ({
    textSearch: '',
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'Afiliado', value: 'name' },
      { align: 'center', class: 'table-header', text: 'Taxa Depósitos', value: 'txDeposit' },
      { align: 'center', class: 'table-header', text: 'Taxa Retiradas', value: 'txWithdraw' },
      { align: 'center', class: 'table-header', text: 'Taxa Custos', value: 'txCosts' },
      { align: 'start', class: 'table-header', text: 'Data Criação', value: 'created' },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ],
    loadingBtnsBloqueios: false
  }),
  computed: {
    ...mapGetters('expenseConfigs', ['listaItens', 'totalItens', 'item']),
    ...mapGetters('roles', ['permiteAcao']),
  },

  methods: {
    ...mapActions('expenseConfigs', ['getItens', 'getItem', 'deletarItem']),
    async editItem (item) {
      this.loadingPag = true
      await this.getItem(item).then(() => {
        Events.$emit('cadastro::openModalCadastro')
      }).catch(() => {
        errorSnackbar('Error ao selecionar o item')
      }).finally(() => {
        this.loadingPag = false
      })
    },
    buscar(val) {
      this.loadingPag = true
      this.objCampoBusca['_addlFilter'] = { "rcp:name_ilike":`${val}%` }
      this.getItens({ _addlFilter: { "rcp:name_ilike":`${val}%` } })
        .then(result => {
          if (result.data.totalItens < 1) {
            errorSnackbar('Não há dados disponíveis')
          }
        })
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => { this.loadingPag = false })
    },
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/table';
.v-tooltip__content {
  opacity: 1 !important;
}
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {
    // border-top: 5px solid $colorPrimary;
    // border-top-left-radius: 0 !important;
    // border-top-right-radius: 0 !important;

    .v-data-table-header-mobile {
      display: none;
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }

  .table-installations {
    table {
      @media (min-width: 1260px) {
        min-width: 1270px !important;
  
        td {
          padding: 0 5px !important;
        }
      }
    }
    .table-header-name {
      width: 150px !important;
    }

    .text-name {
      width: 150px!important;
      display: inline-block;
      line-height: 0.9;
    }
  }
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
